import styled from "styled-components";
import { useGame } from "../contexts";

const Container = styled.div`
  z-index: 2;
  position: fixed;
  bottom: 10px;
  right: 10px;
  background: white;
  color: black;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 8px 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  text-align: center;
  min-width: 130px;
`;

const DiceRow = styled.div`
  display: flex;
  gap: 6px;
  justify-content: center;
  margin: 4px 0;
`;

const Die = styled.div`
  width: 28px;
  height: 28px;
  border: 2px solid #333;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.1rem;
  background: #f8f8f8;
`;

const Label = styled.div`
  font-size: 0.75rem;
  color: #555;
`;

const Total = styled.div`
  font-size: 0.85rem;
  margin-top: 2px;
`;

export const DiceBox = () => {
  const { room } = useGame();
  const lastRoll = room?.lastRoll;

  if (!lastRoll || !lastRoll.dice?.length) {
    return null;
  }

  return (
    <Container>
      <Label>{lastRoll.playerName} rolled</Label>
      <DiceRow>
        {lastRoll.dice.map((value, index) => (
          <Die key={index}>{value}</Die>
        ))}
      </DiceRow>
      <Total>Total: {lastRoll.total}</Total>
    </Container>
  );
};
